import moment from 'moment'
const getTime = date => {
  const arr = []
  arr[0] = moment(moment(date[0]).startOf('day').format('YYYY-MM-DD'))
  arr[1] = moment(moment(date[1]).endOf('day').format('YYYY-MM-DD'))
  return arr
}
const getMoment = mode => {
  let arrDate = []

  switch (mode) {
    case 1: // 未来7天
      arrDate = getTime([moment().add(1, 'day'), moment().add(7, 'days')])
      break
    case 2: // 未来15天
      arrDate = getTime([
        moment().add(1, 'day'), // 从明天开始
        moment().add(15, 'days') // 未来第15天
      ])
      break
    default:
      break
  }
  return arrDate
}

const rangePresets = {
  未来7天: getMoment(1),
  未来15天: getMoment(2)
}
export { rangePresets }
